import { mobileCheck, showAlert } from "../../Helpers/GlobalFunctions";
import { qrCode } from "./escposQr";
import { htmlToEscpos } from "./htmlToEscpos";
// Singleton service for managing the Bluetooth printer connection
class PrinterServiceNew {
    constructor() {
        this.device = null;
        this.characteristic = null;
        this.serviceuuid = null;
        this.connected = false;
        this.labelwidth = 2.1;
        this.labelheight = 1;
        this.dpi = 203;
        this.timeout = 20;
        this.mtu = 512;
        this.ix = -1;
        this.iy = -10;
        this.dx = 0;
        this.dy = -5;
        this.tinit = 200;
        this.tdraw = 500;
        this.tprintgap = 300;
        this.tformfeed = 1000;
        this.tchunk = 30;
        this.totheight =230;
    }
    assignvalue(poprinterprops, pstype, device) {
        if (typeof poprinterprops === "object" && poprinterprops !== null) {
            if (pstype === "assign") {
                this.labelwidth = poprinterprops.lblwidth;
                this.labelheight = poprinterprops.lblheight;
                this.dpi = poprinterprops.dpi;
                this.timeout = poprinterprops.timeout;
                this.mtu = poprinterprops.mtu;
            }
            else {
                let lsdevtype = "w";
                let lbismobile = mobileCheck();
                if (lbismobile === true) {
                    lsdevtype = "m";
                }
                let loPrinters = poprinterprops.filter(e => e.devnm === device.name && e.dtyp === lsdevtype);
                if (loPrinters.length > 0) {
                    this.labelwidth = loPrinters[0].lblwidth;
                    this.labelheight = loPrinters[0].lblheight;
                    this.dpi = loPrinters[0].dpi;
                    this.timeout = loPrinters[0].ptimeout;
                    this.mtu = loPrinters[0].mtu;
                }
            }
            this.labelheight = 1.1;
            this.labelwidth = 2.1;
        }
    }
    async initializePrinter() {
        if (!this.characteristic) return;

        // ESC/POS initialization sequence
        const initCommands = new Uint8Array([
            0x1B, 0x40, // Initialize printer
            0x1B, 0x33, 0x00, // Set line spacing to default
        ]);

        await this.characteristic.writeValue(initCommands);
        await new Promise(resolve => setTimeout(resolve, this.tinit));
    }
    async connect(serviceUUID, characteristicUUID, poprinterprops) {
        if (this.connected) return this; // Reuse connection if already active

        const device = await navigator.bluetooth.requestDevice({
            // Accept all devices to allow user to pick; in practice you can filter by namePrefix or services
            acceptAllDevices: true,
            // filters: [{ namePrefix: 'EX58C' }],
            optionalServices: [0xffe0, 0xffe1].map((n) => {
                // numeric to uuid
                const hex = n.toString(16).padStart(4, "0");
                return serviceUUID;
                //return `0000${hex}-0000-1000-8000-00805f9b34fb`;
            }),
        });
        this.assignvalue(poprinterprops, '', device);
        const server = await device.gatt.connect();
        let characteristic = null;
        // Try common service/characteristic combos
        const candidateServices = [
            serviceUUID
        ];
        for (const svc of candidateServices) {
            try {
                const service = await server.getPrimaryService(svc);
                // Try common characteristic ids
                const charCandidates = [
                    characteristicUUID
                ];
                for (const ch of charCandidates) {
                    try {
                        const characteristicTry = await service.getCharacteristic(ch);
                        // if found, store and break
                        characteristic = characteristicTry;
                        break;
                    } catch (e) {
                        // ignore
                    }
                }
                // characteristic = characteristicUUID
                if (characteristic) break;
            } catch (e) {
                // ignore
            }
        }
        this.device = device;
        this.characteristic = characteristic;
        this.serviceuuid = serviceUUID;
        this.characteristicuuid = characteristicUUID;
        this.connected = true;
        if (!characteristic) {
            // setStatus("Could not find common writable characteristic. You may still be able to write if you know the service/characteristic UUIDs. See logs.");
            console.warn("No characteristic found. Device: ", device);
        } else {
            // setPrinterCharacteristic(characteristic);
            // setStatus("Connected and characteristic found — ready to print.");
        }
        // Handle disconnection
        device.addEventListener("gattserverdisconnected", () => {
            this.connected = false;
            console.warn("Printer disconnected");
        });
        return this;
    }
    async reconnect(serviceUUID, characteristicUUID, poprinterprops) {
        if (this.connected) return this; // Reuse connection if already active

        const device = await navigator.bluetooth.requestDevice({
            filters: [{ services: [serviceUUID] }],
        });
        this.assignvalue(poprinterprops, '', device);
        const server = await device.gatt.connect();
        const service = await server.getPrimaryService(serviceUUID);
        const characteristic = await service.getCharacteristic(characteristicUUID);

        this.device = device;
        this.characteristic = characteristic;
        this.connected = true;
        console.log("Reconnected to printer after refresh");
        // Handle disconnection
        device.addEventListener("gattserverdisconnected", () => {
            this.connected = false;
            console.warn("Printer disconnected");
        });
        return this;
    }

    async print(text, pstype, poitem, pssize) {
        if (!this.connected || !this.characteristic) {
            return { status: false, errmsg: "Printer not connected" };
        }
        if (pstype === "QR" || pstype === "qr") {
            return await this.printqr(text, pstype);
        }
        else if (pstype === "HTML" || pstype === "html") {
            return await this.printhtml(text, pstype);
        }
        else if (pstype === "IMAGE" || pstype === "image") {
            return await this.printimage(text, pstype, poitem, pssize);
        }
        else {
            try {
                const data = new TextEncoder().encode(text);
                await this.characteristic.writeValue(data);
                return { status: true, errmsg: "Successfully Printed" };
            }
            catch (err) {
                return { status: false, errmsg: err };
            }
        }
    }
    async printqr(text, pstype) {
        try {
            const data = qrCode(text, 6);
            await this.characteristic.writeValue(data);
            return { status: true, errmsg: "Successfully Printed" };
        }
        catch (err) {
            return { status: false, errmsg: err };
        }
    }
    async printhtml(text, pstype) {
        try {
            const data = htmlToEscpos(text);
            await this.characteristic.writeValue(data);
            return { status: true, errmsg: "Successfully Printed" };
        }
        catch (err) {
            return { status: false, errmsg: err };
        }
    }
    async printimage(text, pstype, poitem, pssize) {
        if (!this.connected || !this.characteristic) {
            return { status: false, errmsg: "Printer not connected" };
        }

        try {
            // Parse size parameters if provided
            if (typeof pssize === "string" && pssize !== "") {
                let parsedsize = JSON.parse(pssize);
                if (Array.isArray(parsedsize) && parsedsize.length > 0) {
                    this.labelwidth = parsedsize[0].width ? Number(parsedsize[0].width) : this.labelwidth;
                    this.labelheight = parsedsize[0].height ? Number(parsedsize[0].height) : this.labelheight;
                    this.dx = parsedsize[0].left ? Number(parsedsize[0].left) : this.dx;
                    this.dy = parsedsize[0].top ? Number(parsedsize[0].top) : this.dy;
                    this.mtu = parsedsize[0].mtu ? Number(parsedsize[0].mtu) : this.mtu;
                    this.tinit = parsedsize[0].tinit ? Number(parsedsize[0].tinit) : this.tinit;
                    this.tdraw = parsedsize[0].tdraw ? Number(parsedsize[0].tdraw) : this.tdraw;
                    this.tprintgap = parsedsize[0].tprintgap ? Number(parsedsize[0].tprintgap) : this.tprintgap;
                    this.tformfeed = parsedsize[0].tformfeed ? Number(parsedsize[0].tformfeed) : this.tformfeed;
                    this.tchunk = parsedsize[0].tchunk ? Number(parsedsize[0].tchunk) : this.tchunk;
                    this.totheight = parsedsize[0].totheight ? Number(parsedsize[0].totheight) : this.totheight;
                }
            }

            // Create image and wait for it to load
            const img = new Image();
            img.crossOrigin = "anonymous"; // Handle CORS if needed

            // Wrap image loading in a promise
            await new Promise((resolve, reject) => {
                img.onload = resolve;
                img.onerror = reject;
                img.src = text;
            });

            // Create canvas if it doesn't exist
            let canvas = document.getElementById("canvasprinter");
            if (!canvas) {
                canvas = document.createElement("canvas");
                canvas.id = "canvasprinter";
                canvas.style.display = "none";
                document.body.appendChild(canvas);
            }

            // Clear any existing image data
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Set canvas dimensions
            canvas.width = this.labelwidth;
            canvas.height = this.labelheight;

            // Print multiple items with delays between them
            const results = [];
            //this.initializePrinter()
            for (let i = 0; i < (poitem || 1); i++) {
                try {
                    // Draw the image on canvas
                    await this.drawPreview(img, canvas);

                    // Add a small delay to ensure canvas is ready (especially for mobile)
                    await new Promise(resolve => setTimeout(resolve, this.tdraw));
                    // Save the image
                   // await this.saveCanvasAsImage();
                    // Send to printer with proper error handling
                    const result = await this.onPrintViaBluetooth();
                    results.push(result);
                   
                    // IMPORTANT: Add delay between prints for mobile devices
                    // Mobile Bluetooth needs more time between transmissions
                    if (i < (poitem || 1) - 1) {
                        await new Promise(resolve => setTimeout(resolve, this.tprintgap)); // 300ms delay between labels
                    }

                } catch (err) {
                    console.error(`Error printing label ${i + 1}:`, err);
                    results.push({ status: false, errmsg: err.message || err });
                }
            }

            // Check if all prints were successful
            const allSuccessful = results.every(r => r.status !== false);
            return {
                status: allSuccessful,
                errmsg: allSuccessful ? "Successfully Printed" : "Some labels failed to print",
                details: results
            };

        } catch (err) {
            return { status: false, errmsg: err.message || err };
        }
    }
    /*   async printimage(text, pstype, poitem, pssize) {
          console.log(pssize);
          try {
              const img = new Image();
              if (typeof pssize === "string" && pssize !== "") {
                  let parsedsize = JSON.parse(pssize);
                  if (Array.isArray(parsedsize) && parsedsize.length > 0) {
                      this.labelwidth = parsedsize[0].width ? Number(parsedsize[0].width) : this.labelwidth;
                      this.labelheight = parsedsize[0].height ? Number(parsedsize[0].height) : this.labelheight;
                      this.dx = parsedsize[0].left ? Number(parsedsize[0].left) : this.dx;
                      this.dy = parsedsize[0].top ? Number(parsedsize[0].top) : this.dy;
                  }
              }
              console.log(this);
              img.onload = async () => {
                  if (poitem > 1) {
                      for (let i = 0; i < poitem; i++) {
                          await this.drawPreview(img);
                          await this.onPrintViaBluetooth();
                      }
                  }
                  else {
                      await this.drawPreview(img);
                      await this.onPrintViaBluetooth();
                  }
                  return { status: true, errmsg: "Successfully Printed" };
              };
              img.src = text;
  
          }
          catch (err) {
              return { status: false, errmsg: err };
          }
      } */
    async saveCanvasAsImage() {
        const canvas = document.getElementById("canvasprinter");
        const link = document.createElement('a');
        link.download = 'label.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
    }
    /*     async drawPreview(img) {
            const canvas = document.getElementById("canvasprinter");
            const ctx = canvas.getContext("2d");
            // compute desired pixel size based on inch settings and DPI
            // const pw = Math.round(this.labelwidth);
            // const ph = Math.round(this.labelheight);
            // canvas.width = pw;
            // canvas.height = ph;
            canvas.width = this.labelwidth;
            canvas.height = this.labelheight;
            // clear
            ctx.fillStyle = "white";
            ctx.fillRect(this.dx, this.dy, this.labelwidth, this.labelheight);
            // calculate image fit (contain)
            // const ratio = Math.min(pw / img.width, ph / img.height);
            // const iw = Math.round(img.width * ratio);
            // const ih = Math.round(img.height * ratio);
            // const ix = Math.round((pw - iw) / 2);
            // const iy = (Math.round((ph - ih) / 2));
            //        ctx.drawImage(img, ix, iy, iw, ih); - commented by guna
            ctx.drawImage(img, this.dx, this.dy, this.labelwidth, this.labelheight);
            // Save the image - call this when needed
            await this.saveCanvasAsImage();
            //showAlert("pw - " + pw + " ph - " + ph + " iw - " + iw + " ih - " + ih + " ix - " + ix + " iy - " + iy );
        } */
    /*     async drawPreview(img) {
        const canvas = document.getElementById("canvasprinter");
        const ctx = canvas.getContext("2d");
        
        // Set canvas to actual label dimensions
        canvas.width = this.labelwidth;
        canvas.height = this.labelheight;
        
        // Clear entire canvas with white background
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, this.labelwidth, this.labelheight);
        
        // Calculate image scaling to fit within the printable area
        // (label dimensions minus the offsets)
        const printableWidth = this.labelwidth - this.dx;
        const printableHeight = this.labelheight - this.dy;
        
        // Calculate scale to fit image within printable area (maintain aspect ratio)
        const scaleX = printableWidth / img.width;
        const scaleY = printableHeight / img.height;
        const scale = Math.min(scaleX, scaleY); // Use the smaller scale to fit
        
        const scaledWidth = img.width * scale;
        const scaledHeight = img.height * scale;
        
        // Center the image within the printable area
        const x = this.dx + (printableWidth - scaledWidth) / 2;
        const y = this.dy + (printableHeight - scaledHeight) / 2;
        
        // Draw the scaled image
        ctx.drawImage(img, x, y, scaledWidth, scaledHeight);
        
        // Save the image
        await this.saveCanvasAsImage();
    } */
    /*     async drawPreview(img) {
        const canvas = document.getElementById("canvasprinter");
        const ctx = canvas.getContext("2d");
        canvas.width = this.labelwidth;
        canvas.height = this.labelheight;
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, this.labelwidth, this.labelheight);
        ctx.drawImage(img, this.dx, this.dy, 
                      this.labelwidth - this.dx, 
                      this.labelheight - this.dy);
        await this.saveCanvasAsImage();
    } */
    // Update drawPreview to accept canvas parameter
    /* async drawPreview(img, canvas = null) {
        if (!canvas) {
            canvas = document.getElementById("canvasprinter");
            if (!canvas) {
                canvas = document.createElement("canvas");
                canvas.id = "canvasprinter";
                canvas.style.display = "none";
                document.body.appendChild(canvas);
            }
        }
        
        const ctx = canvas.getContext("2d");
        
        // Set canvas dimensions
        canvas.width = this.labelwidth;
        canvas.height = this.labelheight;
        
        // Clear with white background
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, this.labelwidth, this.labelheight);
        
        // Draw the image
        ctx.drawImage(img, this.dx, this.dy, 
                      this.labelwidth - this.dx, 
                      this.labelheight - this.dy);
    } */
    // Update onPrintViaBluetooth to return proper result
    // Update drawPreview to accept canvas parameter
    async drawPreview(img, canvas = null) {
        if (!canvas) {
            canvas = document.getElementById("canvasprinter");
            if (!canvas) {
                canvas = document.createElement("canvas");
                canvas.id = "canvasprinter";
                canvas.style.display = "none";
                document.body.appendChild(canvas);
            }
        }

        const ctx = canvas.getContext("2d");

        // Set canvas dimensions
        canvas.width = this.labelwidth;
        canvas.height = this.totheight ; // this.labelheight;

        // Clear with white background
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, this.labelwidth, this.labelheight);
      
        // Draw the image
        ctx.drawImage(img, this.dx, this.dy ,
            this.labelwidth ,
            this.labelheight );
    }
    async onPrintViaBluetooth() {
        try {
            showAlert("New - height - " + this.labelheight + " width - " + " mtu - " + this.mtu + " time - " + this.timeout, "info");

            const canvas = document.getElementById("canvasprinter");
            if (!canvas) {
                throw new Error("Canvas not found");
            }

            // If characteristic not set, try to discover again
            let characteristic = this.characteristic;
            if (!characteristic) {
                throw new Error("Printer characteristic not available");
            }

            const out = await this.convertCanvasToFormat(canvas);
            let arr;

            if (out instanceof Blob) {
                arr = new Uint8Array(await out.arrayBuffer());
            } else if (out instanceof Uint8Array) {
                arr = out;
            } else if (out instanceof ArrayBuffer) {
                arr = new Uint8Array(out);
            } else {
                arr = new Uint8Array(out);
            }

            // Send to printer with delay between chunks for mobile
            await this.writeToCharacteristic(characteristic, arr);

            // Send form feed command to advance to next label
            // await this.sendFormFeed();

            return { status: true };

        } catch (err) {
            console.error("Print error:", err);
            return { status: false, errmsg: err.message || err };
        }
    }

    // Add form feed method to advance paper
    async sendFormFeed() {
        if (!this.characteristic) return;

        // ESC/POS form feed command
        const formFeed = new Uint8Array([0x0C]); // ASCII form feed
        await this.characteristic.writeValue(formFeed);

        // Small delay to let printer process
        await new Promise(resolve => setTimeout(resolve, this.tformfeed));
    }

    // Update writeToCharacteristic with better mobile handling
    async writeToCharacteristic(characteristic, data) {
        const u8 = data instanceof Uint8Array ? data : new Uint8Array(data);
        const mtu = this.mtu || 512;
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        // Use smaller chunks and longer delays for mobile
        const chunkSize = mtu; // isMobile ? 64 : mtu; // Smaller chunks for mobile
        const delayBetweenChunks = this.tchunk; // isMobile ? 30 : 10; // Longer delay for mobile -- guna
        //GUNA -19.01.2026
        //const chunkSize =64 ; // isMobile ? 64 : mtu; // Smaller chunks for mobile
        //const delayBetweenChunks =50; // isMobile ? 20 : 10; // Longer delay for mobile


        for (let i = 0; i < u8.length; i += chunkSize) {
            const chunk = u8.slice(i, i + chunkSize);
            await characteristic.writeValue(chunk);

            // Add delay between chunks, especially important for mobile
            if (delayBetweenChunks > 0 && i + chunkSize < u8.length) {
                await new Promise(resolve => setTimeout(resolve, delayBetweenChunks));
            }
        }
    }

    async convertCanvasToFormat(canvas) {
        const mono = await this.canvasToMonochromeData(canvas);
        return await this.escposFromMono(mono);
        // throw new Error("Unknown format");
    }
    // Convert canvas to monochrome bitmap (dither optional)
    async canvasToMonochromeData(canvas, threshold = 127) {
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        const w = canvas.width;
        const h = canvas.height;
        const imgData = ctx.getImageData(0, 0, w, h);
        const data = imgData.data;
        // simple thresholding for now
        const mono = new Uint8Array(w * h);
        for (let i = 0; i < w * h; i++) {
            const r = data[i * 4 + 0];
            const g = data[i * 4 + 1];
            const b = data[i * 4 + 2];
            // luminance
            const lum = 0.299 * r + 0.587 * g + 0.114 * b;
            mono[i] = lum < threshold ? 1 : 0; // 1 = black
        }
        return { width: w, height: h, pixels: mono };
    }
    async escposFromMono(mono) {
        const { width, height, pixels } = mono;
        // ESC/POS raster format expects width in bytes (8 pixels per byte)
        const bytesPerLine = Math.ceil(width / 8);
        const data = [];
        // GS v 0: 0x1D 0x76 0x30 m xL xH yL yH d...
        // m = mode (0 normal)
        const xL = bytesPerLine & 0xff;
        const xH = (bytesPerLine >> 8) & 0xff;
        const yL = height & 0xff;
        const yH = (height >> 8) & 0xff;
        // header
        data.push(0x1d, 0x76, 0x30, 0x00, xL, xH, yL, yH);
        for (let y = 0; y < height; y++) {
            for (let bx = 0; bx < bytesPerLine; bx++) {
                let byte = 0;
                for (let bit = 0; bit < 8; bit++) {
                    const x = bx * 8 + bit;
                    const idx = y * width + x;
                    if (x < width && pixels[idx]) {
                        byte |= (0x80 >> bit);
                    }
                }
                data.push(byte);
            }
        }
        return new Uint8Array(data);
    }
    /*  async writeToCharacteristic(characteristic, data) {
         // WebBluetooth characteristic.writeValue accepts ArrayBuffer. Some printers require small chunks (<20-512 bytes).
         // console.log( characteristic.service.device.mtu); // || 180;
         const mtu = this.mtu; // safe chunk size
         const u8 = data instanceof Uint8Array ? data : new Uint8Array(data);
         for (let i = 0; i < u8.length; i += mtu) {
             const chunk = u8.slice(i, i + mtu);
             await characteristic.writeValue(chunk);
             // small delay optional
             //await new Promise((r) => setTimeout(r, this.timeout));
         }
     } */
    disconnect() {
        if (this.device?.gatt.connected) {
            this.device.gatt.disconnect();
            this.connected = false;
        }
    }
}

// Export a single shared instance
export const printerService = new PrinterServiceNew();